import { z } from 'zod';
z.setErrorMap((issue, ctx) => {
    if (issue.code === 'too_small' && issue.type === 'array') {
        return { message: `Should have at least 1 item${issue.minimum === 1 ? '' : 's'}` };
    }
    return { message: ctx.defaultError };
});
